import React, { Component, createRef } from "react";
import { withAlert } from "react-alert"; // HOC to show the alert message
import Config, { entryMode } from "../../../data/siteconfig";
import sHelpers from "../../../modules/helpers/statichelpers";
//import AddItemPopup from '../../../component/popup/additem';
import AddItemRatePopup from '../../../component/popup/additemrate';
import "./indent.scss";
import "./autocomplete.scss";
import PageLoading from "../../../component/loadinganimation/pageloading";

const addItemRef = React.createRef();
// Page is Created by vijay on 07-10-2024
class indententry extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			paddingTop: 0,
			paddingBottom: 0,
			propertyList: [],
			storeList: [],
			departmentList: [],
			selectedPropertyCode: 0,
			selectedPropertyName: "",
			selectedStoreCode: 0,
			selectedStoreName: "",
			selectedDepartmentCode: 0,
			selectedDepartmentName: "",
			indentNo: 0,
			indentDate: "",
			items: [],
			selectedItems: [],
			fields: {},
			btnDisabled: false,
			btnVisible: true,
			btnDeleteVisabled: false,
			ctrlDisabled: false,
			selectedItemCode: 0,
			selectedItemUnits: "",
			selectedItemStock: 0,
			selectedItemRate: 0,
			filteredSuggestions: [],
			itemInputValue: "",
			selectedItemValue: "",
			mode: "-",
			selectedIndentCode: 0,
			displayIndentNo: 0,
			indentLogin: "",
			showStoreList: true,
			IndentAmount: "",
			selectedRecipeCode: null,
			editdisabled: false,
			resetdisabled: true,
			showEditRateIcon: false,
		};
		this.mainRef = createRef();
		this.headerRef = createRef();
		this.footerRef = createRef();
		this.itemSearchRef = React.createRef();
		this.qtyRef = React.createRef();
		this.enteredByRef = React.createRef();
		this.handleDepartmentIndentList = this.handleChangeDepartmentList.bind(this);
	}

	updateStyles = () => {
		const windowHeight = window.innerHeight;
		const headerHeight = this.headerRef.current
			? this.headerRef.current.offsetHeight
			: 0;
		const footerHeight = this.footerRef.current
			? this.footerRef.current.offsetHeight
			: 0;

		if (this.mainRef.current) {
			this.mainRef.current.style.minHeight = `${windowHeight}px`;
			this.setState({
				paddingTop: headerHeight + 10,
				paddingBottom: footerHeight + 10,
			});
		}
	};

	componentDidMount() {
		this.updateStyles();
		window.addEventListener("resize", this.updateStyles);

		if (!sHelpers.LoggedinInputValidation()) {
			this.props.alert.error("Session Expired! Please log in again.");
			this.setState({ loading: true });
			setTimeout(() => {
				this.props.history.push("/login");
			}, Config.minMsgTimeout);
			return false;
		}

		this.setState({
			propertyList: sHelpers.secureStorage.getItem("inv.user.properties"),
		});

		if (sHelpers.secureStorage.getItem("inv.user.properties").length > 0) {
			let indentDate = sHelpers.secureStorage.getItem(
				"inv.user.properties"
			)[0].RunDate;
			const _filterStore = sHelpers.secureStorage
				.getItem("inv.user.stores")
				.filter(
					(s) =>
						s.PropertyCode ===
						sHelpers.secureStorage.getItem("inv.user.properties")[0]
							.PropertyCode
				);

			this.setState({
				storeList: _filterStore,
				indentDateDate: indentDate,
				selectedPropertyCode: sHelpers.secureStorage.getItem(
					"inv.user.properties"
				)[0].PropertyCode,
				selectedPropertyName: sHelpers.secureStorage.getItem(
					"inv.user.properties"
				)[0].PropertyName,
			});

			if (_filterStore.length > 0) {
				this.setState({
					selectedStoreCode: _filterStore[0].StoreCode,
					selectedStoreName: _filterStore[0].StoreName,
				});
				this.getStoreItems(
					sHelpers.secureStorage.getItem("inv.user.properties")[0].PropertyCode,
					_filterStore[0].StoreCode
				);
			}
		}

		//if first property having indentlist
		const propertyList = sHelpers.secureStorage.getItem("inv.user.properties");

		if (propertyList && propertyList.length > 0) {
			this.setState({ propertyList }, () => {
				// Get the first property code after state update
				const firstPropertyCode = this.state.propertyList[0].PropertyCode;

				// Call handleChangeProperty with the first property code
				this.handleChangeProperty({ target: { value: firstPropertyCode } });
			});
		}

		if (this.props.location.state) {
			this.setState({ mode: this.props.location.state.mode });
			this.setState({
				indentno: this.props.location.state.indentno,
			});
			setTimeout(() => {
				if (
					this.props.location.state.mode === "View" ||
					this.props.location.state.mode === "Delete" ||
					this.props.location.state.mode === "Edit"
				) {
					this.getViewIndentList(
						this.props.location.state.indentno
					);
				}

				this.handleMode();
			}, Config.minMsgTimeout);
		}
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateStyles);
	};

	handleAddItemRatePopup() {
		if (addItemRef.current) {
			addItemRef.current.handleAddItemRatePopup();
		}
	};

	handleRateUpdate = (newRate) => {
		this.setState({
			selectedItemRate: newRate,
		});
	};

	getStoreItems = async (propertyCode, storeCode) => {
		try {
			var requestIP = "0.0.0.1";
			this.setState({ storeItems: [] });
			const encodedCredentials = btoa(
				`${Config.invAPIUserName}:${Config.invAPIPassword}`
			);

			await fetch(
				Config.baseAPIUrl +
				"common/storeitems?propertycode=" +
				propertyCode +
				"&storecode=" +
				storeCode +
				"&requestip=" +
				requestIP,
				{
					method: "GET",
					headers: {
						Authorization: "Basic " + encodedCredentials,
						"Content-type": "application/json",
					},
				}
			)
				.then((res) => res.json())
				.then((response) => {
					//  console.log(response);
					if (response.IsSuccessful) {
						const mappedSuggestions = response.Items.map((item) => ({
							ItemName: item.ItemName,
							ItemCode: item.ItemCode,
							UOM: item.Units,
							Rate: item.CurrentRate === 0 ? item.LatestRate : item.CurrentRate,
							CurrentStock: item.CurrentStock,
						}));
						this.setState({
							items: mappedSuggestions,
							filteredSuggestions: [],
							itemInputValue: "",
							selectedItemCode: 0,
							selectedItemValue: "",
						});
					} else {
						this.setState({ loading: false });
						this.props.alert.error(response.Message);
						sHelpers.secureStorage.setItem("inv.store.items", []);
					}
				})
				.catch((err) => {
					console.log(err);
					// this.setState({ loading: false });
					this.props.alert.error(err.message);
					return;
				});
		} catch (error) {
			console.error("Fetch error:", error);
			// You can set an error state here or handle it as needed
			throw error;
		}
	};

	handleChangeProperty = async (event) => {
		const selectedPropertyCode = event.target.value;

		const _filterStore = sHelpers.secureStorage
			.getItem("inv.user.stores")
			.filter((s) => s.PropertyCode === Number(selectedPropertyCode));

		const _filterProperty = sHelpers.secureStorage
			.getItem("inv.user.properties")
			.filter((p) => p.PropertyCode === Number(selectedPropertyCode));

		this.setState({
			storeList: _filterStore,
			selectedTypeId: "1",
			showStoreList: true,
			indentDate:
				_filterProperty.length > 0 ? _filterProperty[0].RunDate : "",
			selectedPropertyCode: selectedPropertyCode,
			selectedPropertyName:
				_filterProperty.length > 0 ? _filterProperty[0].PropertyName : "",
		});

		if (this.props.location.state.mode !== "Edit") {
			this.setState({ selectedItems: [] });
		}

		if (_filterStore.length > 0) {
			this.setState({
				selectedStoreCode: _filterStore[0].StoreCode,
				selectedStoreName: _filterStore[0].StoreName,
			});
			this.getStoreItems(selectedPropertyCode, _filterStore[0].StoreCode);
		}

		await this.getdepartmentList(selectedPropertyCode);

		const { departmentList } = this.state;
		if (departmentList.length > 0) {
			this.setState({ selectedDepartmentCode: departmentList[0].DepartmentCode, selectedDepartmentName: departmentList[0].DepartmentName });
		} else {
			this.setState({ selectedDepartmentCode: 0, selectedDepartmentName: "" });
		}

		if (this.props.location.state.mode !== "Edit") {
			this.clearData();
		}
	};

	handleReload() {
		window.location.reload(true);
	};

	handleAddItemClick() {
		let getSelectItems = this.state.selectedItems;
		let findItem = [];

		if (parseInt(this.state.selectedTypeId) === 1) {
			findItem = getSelectItems.filter(
				(itm) =>
					itm.ItemCode === parseInt(this.state.selectedItemCode) && // Corrected capitalization: 'ItemCode'
					itm.StoreCode === parseInt(this.state.selectedStoreCode)
			);
		}


		//const trimmedItemValue = this.state.selectedItemValue.toString().trim();



		if (findItem.length) {
			this.props.alert.error("Item already added.");
			document.getElementById("item-name").focus();
			return false;
		}

		const selectedItem = document.getElementById("item-name");
		const qty = this.state.fields["indentqty"]
			? parseFloat(this.state.fields["indentqty"])
			: 0;
		const remarks = this.state.fields["indentitemremarks"]
			? this.state.fields["indentitemremarks"]
			: "";
		let fields = this.state.fields;

		if (!sHelpers.validateNumeric(qty)) {
			this.props.alert.error("Please enter the Valid Qty");
			document.getElementById("indent-qty").focus();
			fields["indentqty"] = "";
			this.setState({ fields });
			this.handleScrollIntoView(this.qtyRef);
			return false;
		}
		if (!this.state.selectedItemValue) {
			this.setState({ itemInputValue: "" });
			this.props.alert.error("Please select the item");
			document.getElementById("item-name").focus();
			fields["indentqty"] = "";
			this.setState({ fields });
			this.handleScrollIntoView(this.itemSearchRef);
			return false;
		}

		// console.log('qty',qty);
		if (qty <= 0) {
			this.props.alert.error("Please enter the valid qty");
			fields["indentqty"] = "";
			this.setState({ fields });
			window.scrollTo(0, 0);
			document.getElementById("indent-qty").focus();
			this.handleScrollIntoView(this.qtyRef);
			return false;
		}

		// if (parseFloat(this.state.selectedItemRate) === 0) {
		// 	this.props.alert.error("Rate must be greater than zero.");
		// 	document.getElementById("item-name").focus();
		// 	fields["indentqty"] = "";
		// 	this.setState({ fields });
		// 	this.handleScrollIntoView(this.itemSearchRef);
		// 	return false;
		// }
		let indentAmount =
			parseFloat(qty.toFixed(3)) * parseFloat(this.state.selectedItemRate);

		let obj = {
			StoreCode: parseInt(this.state.selectedStoreCode),
			StoreName: this.state.selectedStoreName,
			ItemName: selectedItem.value.trim(),
			ItemCode: parseInt(this.state.selectedItemCode),
			units: this.state.selectedItemUnits,
			Rate: parseFloat(this.state.selectedItemRate).toFixed(3),
			Quantity: parseFloat(qty).toFixed(3),
			IndentQuantity: parseFloat(qty).toFixed(3),
			Amount: parseFloat(indentAmount).toFixed(3),
			Remarks: remarks,
		};
		getSelectItems.push(obj);
		this.setState({
			SelectedItems: getSelectItems,
			itemInputValue: "",
			selectedItemValue: "",
			filteredSuggestions: [],
			selectedItemCode: 0,
			selectedItemUnits: "",
			//selectedItemStock: 0,
			selectedItemRate: 0,
			selectedRecipeCode: null,
			showEditRateIcon: false,
		});
		document.getElementById("item-name").focus();
		fields["indentqty"] = "";
		fields["indentitemremarks"] = "";
		this.setState({ fields });
	};

	handleDeleteItemCick(ItemCode, storeCode) {
		let getSelectItems = this.state.selectedItems;
		let index = getSelectItems.findIndex(
			(i) => i.ItemCode === ItemCode && i.storeCode === storeCode
		);
		getSelectItems.splice(index, 1);
		this.setState({ selectedItems: getSelectItems });
		this.props.alert.success("Item deleted successfully!");
		document.getElementById("item-name").focus();
		this.handleScrollIntoView(this.itemSearchRef);
	};

	handleStoreChange(event) {
		const selectedStoreCode = event.target.value; // This is a string
		// Find the selected store by comparing store codes
		const selectedStore = this.state.storeList.find(
			(store) => store.StoreCode === parseInt(selectedStoreCode, 10)
		); // Convert to number

		// Ensure that selectedStore exists to avoid potential errors
		if (selectedStore) {
			this.setState({
				selectedStoreCode: selectedStoreCode, // StoreCode remains a string
				selectedStoreName: selectedStore.StoreName, // Update selectedStoreName state
			});
		}

		this.getStoreItems(this.state.selectedPropertyCode, event.target.value);
	};

	handleChange(field, e) {
		let fields = this.state.fields;
		fields[field] = e.target.value;
		this.setState({ fields });
	};

	handleChangeDepartmentList(event) {
		const selectedDepartmentCode = event.target.value; // Get the selected value
		const selectedDepartment = this.state.departmentList.find(store => store.DepartmentCode === parseInt(selectedDepartmentCode, 10)); // Find the selected department
		this.setState({
			selectedDepartmentCode: selectedDepartmentCode,
			selectedDepartmentName: selectedDepartment ? selectedDepartment.DepartmentName : ""
		});
		//console.log("123", this.state.selectedDepartmentCode);
	};


	handleItemSelect = (
		value,
		ItemCode,
		units,
		rate
	) => {

		this.setState({ selectedItemRate: rate });

		this.setState({
			filteredSuggestions: [],
			itemInputValue: value,
			selectedItemValue: value,
			selectedItemCode: ItemCode,
			selectedItemUnits: units,
			//selectedItemStock: cstock,
			showEditRateIcon: true
		});

		let fields = this.state.fields;
		fields["indentqty"] = "";
		this.setState({ fields });
		document.getElementById("indent-qty").focus();
	};

	handleItemChange = (event) => {
		const inputValue = event.target.value;

		// Filter suggestions based on input value
		const filteredSuggestions = this.state.items.filter((suggestion) =>
			suggestion.ItemName.toLowerCase().includes(inputValue.toLowerCase())
		);

		this.setState({
			itemInputValue: inputValue,
			filteredSuggestions: filteredSuggestions,
		});
		this.setState({
			selectedItemValue: "",
			selectedItemCode: 0,
			selectedItemUnits: "",
			//selectedItemStock: 0,
			selectedItemRate: 0,
			selectedRecipeCode: null,
		});
	};

	handleItemFocus = (event) => {
		event.target.select();
	};

	handleMode() {
		if (entryMode.view === this.state.mode) {
			this.setState({
				btnVisible: false,
				ctrlDisabled: true,
				editdisabled: true,
				resetdisabled: false,
			});
		}

		if (entryMode.edit === this.state.mode) {
			this.setState({
				btnVisible: true,
				ctrlDisabled: false,
				editdisabled: true,
				resetdisabled: false,
			});
		}

		if (entryMode.delete === this.state.mode) {
			this.setState({
				btnDeleteVisabled: true,
				btnVisible: false,
				ctrlDisabled: true,
				editdisabled: true,
				resetdisabled: false,
			});
		}
	}

	clearData() {
		let fields = this.state.fields;
		this.setState({
			selectedItems: [],
			itemInputValue: "",
			selectedItemValue: "",
			filteredSuggestions: [],
			selectedItemCode: 0,
			selectedItemUnits: "",
			//selectedItemStock: 0,
			selectedItemRate: 0,
			selectedRecipeCode: null,
		});
		if (
			!(
				this.props.location.state.mode === "View" ||
				this.props.location.state.mode === "Delete"
			)
		) {
			this.itemSearchRef.current.value = "";
			this.itemSearchRef.current.focus();
		}

		fields["indentqty"] = "";
		this.setState({ fields });
	}

	goBack() {
		this.props.history.push("/indent");
	}

	handleScrollIntoView(scrollRef) {
		window.scrollTo(0, 0);
		setTimeout(() => {
			scrollRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
		}, Config.averageMsgTimeout);
	}

	// department list while property wise
	getdepartmentList = async (propertyCode) => {
		let RequestIP = "127.0.0.0";

		//console.log(propertyCode);
		try {
			const encodedCredentials = btoa(
				`${Config.invAPIUserName}:${Config.invAPIPassword}`
			);

			await fetch(
				Config.baseAPIUrl +
				"common/propertydepartments?" +
				"propertycode=" +
				propertyCode +
				"&requestip=" +
				RequestIP,
				{
					method: "GET",
					headers: {
						Authorization: "Basic " + encodedCredentials,
						"Content-type": "application/json",
					},
				}
			)
				.then((res) => res.json())
				.then((response) => {
					//	console.log("propertydepartments", response);
					if (response.IsSuccessful && response.Departments.length > 0) {
						this.setState({ departmentList: response.Departments });
					} else {
						// this.props.alert.error(response.Message);
						this.setState({ departmentList: [] });
					}
				})
				.catch((err) => {
					console.log(err);
					this.props.alert.error(err.message);
					return;
				});
		} catch (error) {
			console.error("Fetch error:", error);
			throw error;
		}
	};

	//save
	handleSaveModeClick = async (e) => {
		try {
			e.preventDefault();

			if (this.props.location.state.mode === "Edit") {
				this.handleUpdateIndent(
					this.props.location.state.indentno
				); // edit list
				//console.log(this.props.location.state.indentno,'123');
			} else {
				this.handleSaveClick(); // New list
			}
		} catch (err) {
			console.log(err);
		}
	};

	// New mode save
	handleSaveClick = async () => {
		try {
			//	e.preventDefault();

			if (this.state.selectedItems.length === 0) {
				this.props.alert.error("Please add at least one item");
				document.getElementById("item-name").focus();
				this.handleScrollIntoView(this.itemSearchRef);
				return false;
			}

			if (this.state.departmentList.length === 0) {
				this.props.alert.error("Please select the Department");
				document.getElementById("department-list").focus();
				this.handleScrollIntoView(this.itemSearchRef);
				return false;
			}

			this.setState({ btnDisabled: true });

			let postObj = {
				propertycode: parseInt(this.state.selectedPropertyCode), // Ensure it's an integer
				departmentcode: parseInt(this.state.selectedDepartmentCode), // Ensure it's an integer
				departmentname: this.state.selectedDepartmentName, // Ensure it's an integer
				login: sHelpers.secureStorage.getItem("inv.user.name"), // User login from secure storage
				selecteditems: this.state.selectedItems, // Pass the array of items
				orderedby: this.state.fields["orderedby"] || "",
				referenceno: this.state.fields["referenceno"] || "",
				indentapproval: "N", // Default value for indent approval
				requestip: "0.0.0.1", // Static IP
			};

			//console.log("postObj:", JSON.stringify(postObj));

			const encodedCredentials = btoa(
				`${Config.invAPIUserName}:${Config.invAPIPassword}`
			);

			// Make the API request
			await fetch(Config.baseAPIUrl + "store/indents", {
				method: "POST",
				headers: {
					Authorization: "Basic " + encodedCredentials,
					"Content-Type": "application/json",
				},
				body: JSON.stringify(postObj),
			})
				.then((res) => res.json())
				.then((response) => {
					if (response.IsSuccessful) {
						this.props.alert.success(
							response.Message +
							" Indent No: " +
							response.IndentNo
						);
						setTimeout(() => {
							window.location.reload(true);
							this.setState({ selectedItems: [] });
						}, Config.averageMsgTimeout);
					} else {
						this.props.alert.error(response.Message || response[0]);
						this.setState({ btnDisabled: false });
					}
				})
				.catch((err) => {
					console.log(err);
					this.setState({ btnDisabled: false });
					this.props.alert.error(err.message);
				});
		} catch (error) {
			console.error("Fetch error:", error);
			throw error;
		}
	};

	// Edit mode save
	handleUpdateIndent = async () => {
		try {
			//e.preventDefault();

			if (this.state.selectedItems.length === 0) {
				this.props.alert.error("Please add at least one item");
				document.getElementById("item-name").focus();
				this.handleScrollIntoView(this.itemSearchRef);
				return false;
			}

			if (this.state.selectedDepartmentCode === 0) {
				this.props.alert.error("Invalid Department");
				document.getElementById("department-list").focus();
				this.handleScrollIntoView(this.itemSearchRef);
				return false;
			}

			this.setState({ btnDisabled: true });

			let postObj = {
				propertycode: parseInt(this.state.selectedPropertyCode), // Ensure it's an integer
				departmentcode: parseInt(this.state.selectedDepartmentCode), // Ensure it's an integer
				departmentname: this.state.selectedDepartmentName, // Ensure it's an integer
				login: sHelpers.secureStorage.getItem("inv.user.name"), // User login from secure storage
				indentlogin: this.state.indentLogin, // User login from secure storage
				selecteditems: this.state.selectedItems, // Pass the array of items
				orderedby: this.state.fields["orderedby"] || "",
				referenceno: this.state.fields["referenceno"] || "",
				indentapproval: "N", // Default value for indent approval
				requestip: "0.0.0.1", // Static IP
			};

			//console.log("EditpostObj:", JSON.stringify(postObj));

			const encodedCredentials = btoa(
				`${Config.invAPIUserName}:${Config.invAPIPassword}`
			);

			// Make the API request
			await fetch(
				Config.baseAPIUrl +
				"store/indents/" +
				this.props.location.state.indentno +
				"/" +
				this.state.displayIndentNo,
				{
					method: "PUT",
					headers: {
						Authorization: "Basic " + encodedCredentials,
						"Content-Type": "application/json",
					},
					body: JSON.stringify(postObj),
				}
			)
				.then((res) => res.json())
				.then((response) => {
					//console.log("EditKitchen", response);
					if (response.IsSuccessful) {
						this.props.alert.success(
							response.Message +
							" Indent No: " +
							response.IndentNo
						);
						setTimeout(() => {
							window.location.reload(true);
							this.setState({ selectedItems: [] });
						}, Config.averageMsgTimeout);
					} else {
						this.setState({ loading: false });
						this.props.alert.error(response.Message);
					}
				})
				.catch((err) => {
					console.log(err);
					this.props.alert.error(err.message);
					return;
				});
		} catch (error) {
			console.error("Fetch error:", error);
			throw error;
		}
	};

	// view Indent list
	getViewIndentList = async (indentno) => {
		try {
			const encodedCredentials = btoa(
				`${Config.invAPIUserName}:${Config.invAPIPassword}`
			);

			await fetch(
				Config.baseAPIUrl + "store/indents/" + indentno,
				{
					method: "GET",
					headers: {
						Authorization: "Basic " + encodedCredentials,
						"Content-type": "application/json",
					},
				}
			)
				.then((res) => res.json())
				.then((response) => {
					//console.log("getViewIndentList", response);
					if (response.IsSuccessful) {
						this.setState({ selectedItems: response.Detail });

						this.getdepartmentList(response.Header.PropertyCode);

						setTimeout(() => {
							this.setState({
								selectedPropertyCode: response.Header.PropertyCode,
								selectedPropertyName: response.Header.PropertyName,
								selectedDepartmentCode: response.Header.DepartmentCode,
								selectedDepartmentName: response.Header.DepartmentName,
								indentLogin: response.Header.Login,
							});
						}, Config.minMsgTimeout);

						this.setState({
							indentDate:
								response.Header.IndentDate +
								" " +
								response.Header.IndentTime,
							displayIndentNo: response.Header.DisplayIndentNo,
							//fields: { ...this.state.fields },
							fields: { ...this.state.fields, referenceno: response.Header.ReferenceNo, orderedby: response.Header.Orderedby },
						});

						if (this.props.location.state.mode === "Edit") {
							this.handleChangeProperty({
								target: { value: response.Header.PropertyCode },
							});
							this.handleChangeDepartmentList({
								target: { value: response.Header.DepartmentCode },
							});
						}
					} else {
						this.setState({ loading: false });
						this.props.alert.error(response.Message);
					}
				})
				.catch((err) => {
					console.log(err);
					this.props.alert.error(err.message);
					return;
				});
		} catch (error) {
			console.error("Fetch error:", error);
			throw error;
		}
	};

	// Delete Indent list
	deleteIndentList = async () => {
		try {
			const encodedCredentials = btoa(
				`${Config.invAPIUserName}:${Config.invAPIPassword}`
			);

			await fetch(
				Config.baseAPIUrl +
				"store/indents/" +
				this.props.location.state.indentno +
				"/" +
				sHelpers.secureStorage.getItem("inv.user.name"),
				{
					method: "DELETE",
					headers: {
						Authorization: "Basic " + encodedCredentials,
						"Content-type": "application/json",
					},
				}
			)
				.then((res) => res.json())
				.then((response) => {
					//console.log("deleteIndentList", response.Message);
					if (response.IsSuccessful) {
						this.props.alert.success(response.Message);
						setTimeout(() => {
							this.goBack();
						}, 2000);
					} else {
						this.setState({ loading: false });
						this.props.alert.error(response.Message);
						setTimeout(() => {
							this.goBack();
						}, 2000);
					}
				})
				.catch((err) => {
					console.log(err);
					this.props.alert.error(err.message);
					return;
				});
		} catch (error) {
			console.error("Fetch error:", error);
			throw error;
		}
	};

	render() {
		const totalAmount = this.state.selectedItems.reduce(
			(sum, item) => sum + parseFloat(item.Amount),
			0
		);
		const totalItems = this.state.selectedItems.length;
		const { paddingTop, paddingBottom, mode } = this.state;

		return (
			<>
				<PageLoading />
				<main
					className="h-100"
					ref={this.mainRef}
					style={{
						paddingTop: `${paddingTop}px`,
						paddingBottom: `${paddingBottom}px`,
					}}
				>
					<header ref={this.headerRef} className="header position-fixed">
						<div className="row">
							<div className="col-auto">
								<button
									className="btn btn-light btn-44 back-btn"
									onClick={this.goBack.bind(this)}
								>
									<i className="bi bi-arrow-left"></i>
								</button>
							</div>
							<div className="col align-self-center text-center">
								<h5> Indents</h5>
							</div>
						</div>
					</header>

					<div className="main-container container">
						<div className="row mb-3">
							<div className="col">
								<h6 className="title">Indent Entry</h6>
							</div>
							<div className="col-auto align-self-center">
								<span className="tag bg-primary text-white border-0 py-1 px-2 float-end mt-1">
									{mode}
								</span>
							</div>
						</div>
						<div className="row mb-2">
							<div className="col">
								<button
									className="btn btn-default shadow-sm avatar avatar-44 p-0 mb-3 me-2 text-white w-100"
									onClick={this.handleReload.bind(this)}
									disabled={this.state.btnDisabled}
									style={{
										display: this.state.resetdisabled ? "block" : "none",
									}}
								>
									<i className="bi bi-reply-fill me-2"></i>Reset
								</button>
							</div>
							<div className="col">
								<button
									className="btn btn-default shadow-sm avatar avatar-44 p-0 mb-3 me-2 text-white w-100"
									onClick={this.handleSaveModeClick.bind(this)}
									disabled={this.state.btnDisabled}
									style={{ display: this.state.btnVisible ? "block" : "none" }}
								>
									<i className="bi bi-check-lg me-2"></i> Save
								</button>
							</div>
							{this.state.btnDeleteVisabled && (
								<div className="col">
									<button
										className="btn btn-danger shadow-sm avatar avatar-44 p-0 mb-3 me-2 text-white w-100"
										onClick={this.deleteIndentList.bind(this)}
									>
										<i className="bi bi-trash me-2"></i> Delete
									</button>
								</div>
							)}
						</div>
						<div className="row mb-4">
							<div className="col-auto">
								<div className="avatar avatar-44 rounded-10 shadow-sm">
									<i className="bi bi-calendar-range size-22"></i>
								</div>
							</div>

							<div className="col align-self-center ps-0">
								<h6>{this.state.indentDate}</h6>
								<p className="mb-1 text-muted">Date</p>
							</div>

							{this.state.displayIndentNo > 0 && (
								<div className="col align-self-center text-center text-end">
									<h6>{this.state.displayIndentNo}</h6>
									<p className="mb-1 text-muted">Indent No</p>
								</div>
							)}
						</div>
						<div className="row h-100">
							<div className="col-12 col-md-6 col-lg-4">
								<div className="form-floating mb-3">
									<select
										className="form-control"
										id="indent-properties"
										onChange={this.handleChangeProperty.bind(this)}
										value={this.state.selectedPropertyCode}
										disabled={this.state.editdisabled} // Only disabled in edit mode
									>
										{this.state.propertyList.map((prop) => (
											<option value={prop.PropertyCode} key={prop.PropertyCode}>
												{prop.PropertyName}
											</option>
										))}
									</select>
									<label htmlFor="country">Property</label>
								</div>
							</div>

							<div className="col-12 col-md-6 col-lg-4">
								<div className="form-floating mb-3">
									<select
										className="form-control"
										id="department-list"
										onChange={this.handleChangeDepartmentList}
										value={this.state.selectedDepartmentCode}
										disabled={
											this.state.editdisabled ||
											this.state.departmentList.length === 0
										}
									>
										{this.state.departmentList &&
											this.state.departmentList.length > 0 &&
											this.state.departmentList.map((department) => (
												<option
													value={department.DepartmentCode} // Use DepartmentCode for the value
													key={department.DepartmentCode}
												>
													{department.DepartmentName} {/* Display DepartmentName */}
												</option>
											))}
									</select>
									<label htmlFor="department-list">Department List</label>
								</div>
							</div>
							{!(
								this.props.location.state.mode === "View" ||
								this.props.location.state.mode === "Delete"
							) && (
									<>

										{this.state.showStoreList && ( // Conditionally render this block if showStoreList is true
											<div className="col-12 col-md-6 col-lg-4">
												<div className="form-floating mb-3 ">
													<select
														className="form-control"
														id="variation-stores"
														onChange={this.handleStoreChange.bind(this)}
														disabled={this.state.ctrlDisabled}
													>
														{this.state.storeList.map((store) => (
															<option
																value={store.StoreCode}
																key={store.StoreCode}
															>
																{store.StoreName}
															</option>
														))}
													</select>
													<label htmlFor="variation-stores">Store</label>
												</div>
											</div>
										)}
									</>
								)}

							<div className="col-12 col-md-6 col-lg-4">
								<div className="form-group form-floating  mb-3">
									<input
										type="text"
										className="form-control"
										placeholder="Enter Reference No"
										id="indent-referenceno"
										onChange={this.handleChange.bind(this, "referenceno")}
										value={this.state.fields["referenceno"]}
										maxLength="30"
										disabled={this.state.ctrlDisabled}
									/>
									<label htmlFor="indent-referenceno">Ref.No</label>
								</div>
							</div>
							<div className="col-12 col-md-6 col-lg-4">
								<div className="form-group form-floating mb-3">
									<input
										ref={this.enteredByRef}
										type="text"
										className="form-control"
										placeholder="Ordered By"
										id="indent-ordered-by"
										onChange={this.handleChange.bind(this, "orderedby")}
										value={this.state.fields["orderedby"]}
										maxLength="30"
										disabled={this.state.ctrlDisabled}
									/>
									<label htmlFor="indent-ordered-by">Ordered By</label>
								</div>
							</div>

						</div>
						<div className="row">
							{!(
								this.props.location.state.mode === "View" ||
								this.props.location.state.mode === "Delete"
							) && (
									<>
										<div className="col-7">
											<div className="form-group form-floating mb-2 shadow-sm">
												<div className="form-group form-floating">
													<input
														ref={this.itemSearchRef}
														className="autocomplete-input form-control"
														type="text"
														value={this.state.itemInputValue || ""}
														onChange={this.handleItemChange}
														onFocus={this.handleItemFocus}
														id="item-name"
														autoComplete="off"
														disabled={this.state.ctrlDisabled}
													/>

													<label htmlFor="item-name">Item Search</label>
												</div>

												<ul className="autocomplete-suggestions">
													{this.state.filteredSuggestions.map(
														(suggestion, index) => (
															<li
																key={index}
																className="autocomplete-suggestion"
																onClick={() =>
																	this.handleItemSelect(
																		suggestion.ItemName,
																		suggestion.ItemCode,
																		suggestion.UOM,
																		suggestion.Rate
																	)
																}
															>
																{suggestion.ItemName}
															</li>
														)
													)}
												</ul>
											</div>
										</div>

										<div className="col-5">
											<input
												ref={this.qtyRef}
												type="text"
												className="trasparent-input text-end variation-entry-qty"
												id="indent-qty"
												placeholder="0.00"
												onChange={this.handleChange.bind(this, "indentqty")}
												value={this.state.fields["indentqty"]}
												maxLength="10"
												autoComplete="off"
												disabled={this.state.ctrlDisabled}
												inputmode="numeric"
											/>
										</div>

										<div className="col-12 mb-2">
											<span className="text-muted size-12 me-2">
												Units:{" "}
												<span className="text-color-theme size-12 small">
													{this.state.selectedItemUnits}
												</span>{" "}

											</span>
											<span className="text-muted size-12 me-2">
												Rate:{" "}
												<span className="text-color-theme size-12 small">
													{this.state.selectedItemRate}
												</span>{" "}
												{this.state.showEditRateIcon && (
													<i
														className="bi bi-pencil"
														onClick={this.handleAddItemRatePopup.bind(this)}
													></i>
												)}
												{/* <i className="bi bi-pencil" onClick={this.handleAddItemRatePopup.bind(this)}></i> */}
											</span>
										</div>

										<div className="col-12 col-md-12 col-lg-12">
											<div className="form-group form-floating  mb-3">
												<input
													type="text"
													className="form-control"
													placeholder="Enter Remarks"
													id="indent-item-remarks"
													maxLength="200"
													onChange={this.handleChange.bind(this, "indentitemremarks")}
													value={this.state.fields["indentitemremarks"]}
													disabled={this.state.ctrlDisabled}
													autoComplete="off"
												/>
												<label htmlFor="indent-item-remarks">Remarks</label>
											</div>
										</div>
									</>
								)}

							<div className="col-12">
								{/* <button className="btn btn-default shadow-sm avatar avatar-44 p-0 mb-3 me-2 text-white w-100" onClick={this.handleAddItemRatePopup.bind(this)}> */}
								<button
									className="btn btn-default shadow-sm avatar avatar-44 p-0 mb-3 me-2 text-white w-100"
									onClick={this.handleAddItemClick.bind(this)}
									disabled={this.state.btnDisabled}
									style={{ display: this.state.btnVisible ? "block" : "none" }}
								>
									<i className="bi bi-plus-lg me-2"></i> Add Item
								</button>

								{/* Display Total Amount and Total Items */}
								<div className="row my-3">
									{totalAmount > 0 && (
										<div className="col-6 text-start">
											<span className="text-muted size-12 me-2">
												Total Amount:{" "}
												<span className="text-color-theme size-12 small">
													{totalAmount.toFixed(2)}
												</span>
											</span>
										</div>
									)}
									{totalItems > 0 && (
										<div className="col-6 text-end">
											<span className="text-muted size-12 me-2">
												Total Items:{" "}
												<span className="text-color-theme size-12 small">
													{totalItems}
												</span>
											</span>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="row mb-4">
							<div className="card shadow-sm mb-4">
								<div className="col-12 px-0">
									<ul className="list-group list-group-flush bg-none">
										{this.state.selectedItems.map((item, id) => (
											<li className="list-group-item" id={"itm-sl-" + id}>
												<div className="row">
													<div className="col-auto align-self-center text-end">
														<p className="text-color-theme mb-0">
															{item.ItemName}
														</p>
														<p className="text-muted size-12">
															{item.StoreName}
														</p>
														{item.Remarks && (
															<p className="size-12 item-remarks-text"
																title={item.Remarks}
															>
																Remarks: {item.Remarks}
															</p>
														)}
													</div>
													<div className="col align-self-center text-end">
														<p className="mb-0">{item.units}</p>
														<p className="text-muted size-12">
															Rate: {item.Rate}
														</p>
													</div>
													<div className="col align-self-center text-end">
														{/* <p className="mb-0">{item.IndentQuantity}</p> */}
														<p className="text-muted size-12">
															Qty: {item.Quantity}
														</p>
														<p className="text-muted size-12">
															Amount: {item.Amount}
														</p>
													</div>

													<div className="col-auto align-self-center">
														<button
															className="btn btn-light text-danger shadow-sm"
															onClick={this.handleDeleteItemCick.bind(
																this,
																item.ItemCode,
																item.storeCode
															)}
															style={{
																display: this.state.btnVisible
																	? "block"
																	: "none",
															}}
														>
															<i className="bi bi-trash"></i>
														</button>
													</div>
												</div>
											</li>
										))}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</main>
				<AddItemRatePopup
					ref={addItemRef}
					onRateUpdate={this.handleRateUpdate}
				//itemName={this.state.itemInputValue}
				/>
			</>
		);
	}
}
export default withAlert()(indententry);
